<template>
  <div :id="allContainerPopoverId" class="brains-all-popover-container" @mouseleave="mouseOut = true" @mouseenter="mouseOut = false">
    <!-- Botones para los diferentes tipos de activadores -->
    <button v-if="activator === 'mouseover' && button" class="brains-filters1-btn brains-popover-container-activator" @click="showPopover = true" @mouseenter="showPopover = true">
      <slot name="popoverName" /> <font-awesome-icon class="brains-filters1-btn-icon" icon="chevron-down" />
    </button>
    <button v-if="activator === 'click' && button" class="brains-filters1-btn brains-popover-container-activator" @click="showPopover = !showPopover">
      <slot name="popoverName" /> <font-awesome-icon class="brains-filters1-btn-icon" icon="chevron-down" />
    </button>
    <div v-if="activator === 'mouseover' && !button" class="brains-popover-container-activator" @click="showPopover = true" @mouseenter="showPopover = true">
      <slot name="popoverName" />
    </div>
    <div v-if="activator === 'click' && !button" class="brains-popover-container-activator" @click="showPopover = !showPopover">
      <slot name="popoverName" />
    </div>
    <!-- Contenido -->
    <div
      :id="popoverId"
      :class="{
        'brains-show-content': showPopover,
        'brains-hide-content': !showPopover,
        'brains-popover-container--left': position === 'left',
        'brains-popover-container--right': position === 'right',
        'brains-popover-container--top': position === 'top',
        'brains-popover-container--bottom-left': position === 'bottom-left',
        'brains-popover-container--border' : border
      }"
      class="brains-popover-container"
      @mouseleave="mouseOut = true"
      @mouseenter="mouseOut = false"
    >
      <!-- :class="{ 'brains-popover-container--left' : position === 'left' }" -->
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TooltipDataAside',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activator: {
      type: String,
      default: 'mouseover'
    },
    position: {
      type: String,
      default: 'bottom'
    },
    button: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showPopover: false,
      randomNum: 0,
      mouseOut: true,
      timer: ''
    }
  },
  computed: {
    popoverId() {
      return 'brains-popover-' + this.randomNum
    },
    containerPopoverId() {
      return 'brains-container-popover-' + this.randomNum
    },
    allContainerPopoverId() {
      return 'brains-all-popover-container-' + this.randomNum
    }
  },
  watch: {
    value() {
      this.showPopover = this.value
    },
    showPopover(newOne, oldOne) {
      this.$emit('input', this.showPopover)
      if (newOne) {
        this.assignPositions()
        this.mouseOut = false
      }
    },
    mouseOut(newOne, oldOne) {
      if (newOne && this.time > 0) {
        this.timer = setTimeout(() => {
          this.showPopover = false
        }, this.time * 1000)
      } else {
        clearTimeout(this.timer)
      }
    }
  },
  mounted() {
    var vm = this
    vm.generateRandomNum()

    if (this.activator === 'click') {
      window.addEventListener('click', function(e) {
        var item = document.getElementById(vm.popoverId)
        if (item && !item.contains(e.target) && vm.showPopover && !document.getElementById(vm.allContainerPopoverId).contains(e.target)) {
          vm.showPopover = false
        }
      })
    } else {
      window.addEventListener('mouseover', function(e) {
        var item = document.getElementById(vm.popoverId)
        var item2 = document.getElementById(vm.allContainerPopoverId)
        if (item && !item.contains(e.target) && !item2.contains(e.target) && vm.showPopover) {
          vm.showPopover = false
        }
      })
    }
    setTimeout(() => {
      vm.assignPositions()
    }, 200)
  },
  methods: {
    generateRandomNum() {
      this.randomNum = Math.floor(Math.random() * (9999 - 0)) + 0
    },
    /**
     * https://www.aspsnippets.com/Articles/Get-Absolute-Position-Screen-Cordinates-of-HTML-Elements-using-JavaScript.aspx
     */
    GetScreenCordinates(obj) {
      var p = {}
      p.x = obj.offsetLeft
      p.y = obj.offsetTop
      while (obj.offsetParent) {
        p.x = p.x + obj.offsetParent.offsetLeft
        p.y = p.y + obj.offsetParent.offsetTop
        if (obj === document.getElementsByTagName('body')[0]) {
          break
        } else {
          obj = obj.offsetParent
        }
      }
      return p
    },
    assignPositions() {
      var containerData = document.getElementById(this.popoverId)
      var item = document.getElementById(this.allContainerPopoverId)
      var coord = this.GetScreenCordinates(item)
      containerData = document.getElementById(this.popoverId)

      if (containerData === null || containerData === undefined) return

      var width = item.getBoundingClientRect().width

      switch (this.position) {
        case 'bottom-left':
          containerData.style.right = width + 'px'
          break
        case 'left':
          // ATENCIÓN AQUI, YA QUE ES DONDE SE GESTIONA DONDE SE POSICIONA EL TOOLTIP, IMPORTANTE TENER EN CUENTA QUE ESTO ES SOLO PARA DENTRO DE TABS
          // SOLO TABS TABS TABS TABS TABS FUERA DE TABS UTILIZAR EL popoverBtn
          containerData.style.top = coord.y - document.getElementsByClassName('data-sidebar--inner-container')[0].scrollTop - 95 + 'px'
          containerData.style.left = (item.offsetLeft - containerData.getBoundingClientRect().width - 5) + 'px'
          break
        case 'right':
          containerData.style.left = width + 'px'
          containerData.style.top = '-' + (containerData.getBoundingClientRect().height / 2.4) + 'px'
          break
        case 'top':
          containerData.style.bottom = width + 8 + 'px'
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.brains-all-popover-container {
  display: inline-block;
  position: static;
}
.brains-popover-container {
  background-color: white;

  &--right {
    top: 0;
  }

  &--border {
    border: 1px solid rgb(221, 221, 221);
  }
}
</style>
